import { useState, useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import axios from "../../../axios";
// import { GoogleLogin } from '@react-oauth/google';

export default function LoginForm({ onSuccess, onSwitchToRegister }) {
    const { user, setUser } = useContext(AuthContext);
    const [form, setForm] = useState({ phone: "", password: "" });
    const [error, setError] = useState("");

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");
        try {
            const res = await axios.post("/user/login", form);
            setUser(res.data.user); // asumsi respons berisi user
            localStorage.setItem("token", res.data.token);
            if (onSuccess) onSuccess();
        } catch (err) {
            console.error("Login error:", err);
            setError("Login gagal. Cek nomor HP dan password Anda.");
        }
    };

    return (
        <div className="mt-3">
            <p>Silakan login untuk melakukan pemesanan:</p>

            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleLogin} className="mb-3">
                <input
                    type="number"
                    className="form-control mb-2"
                    placeholder="Nomor HP"
                    value={form.phone}
                    onChange={(e) => setForm({ ...form, phone: e.target.value })}
                />
                <input
                    type="password"
                    className="form-control mb-2"
                    placeholder="Password"
                    value={form.password}
                    onChange={(e) => setForm({ ...form, password: e.target.value })}
                />
                <button type="submit" className="btn btn-primary w-100">Login</button>
            </form>


            {/* <GoogleLogin
                onSuccess={async (credentialResponse) => {
                    const id_token = credentialResponse.credential;
                    const res = await axios.post("/auth/google", { id_token });
                    setUser(res.data.user); // dari AuthContext
                    localStorage.setItem("token", id_token);
                }}
                onError={() => {
                    console.error("Login gagal");
                }}
            /> */}

            <p className="text-center mt-2">
        Belum punya akun?{" "}
        <button type="button" className=" p-0" onClick={onSwitchToRegister}>
          Daftar
        </button>
      </p>
        </div>
    );
}
